import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import WhatsAppStatusPanel from '../components/WhatsAppStatusPanel';
import WhatsAppLogsContent from '../components/WhatsAppLogsContent';
import BulkMessagePanel from '../components/BulkMessagePanel';
import WebhookIntegrationsPanel from '../components/WebhookIntegrationsPanel';
import FirmSettingsPanel from '../components/FirmSettingsPanel';
import WhatsAppTemplatesPanel from '../components/WhatsAppTemplatesPanel';

const DashboardPage = ({ defaultTab }) => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(defaultTab || 'dashboard');

  // Route'dan gelen defaultTab değiştiğinde aktif sekmeyi güncelle
  useEffect(() => {
    if (defaultTab) {
      setActiveTab(defaultTab);
    }
  }, [defaultTab]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [firmSlug, setFirmSlug] = useState('');
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [connectionStatus, setConnectionStatus] = useState('unknown');
  const [lastCheck, setLastCheck] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const [panelNotifications, setPanelNotifications] = useState({ unread_total: 0, items: [] });
  const [panelNotificationsLoading, setPanelNotificationsLoading] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [logoMessage, setLogoMessage] = useState('FBAJANS İLE KOLAY E-TİCARET');
  const [logoFile, setLogoFile] = useState(null);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [agreementType, setAgreementType] = useState(''); // 'membership' or 'privacy'
  const [agreementContent, setAgreementContent] = useState('');
  
  // Profesyonel dashboard için yeni state'ler
  const [dashboardStats, setDashboardStats] = useState({
    totalMessages: 0,
    whatsappConnected: false,
    apiEnabled: false,
    licenseDays: 0,
    tokenBalance: 0,
    proxyStatus: 'unknown'
  });
  
  // Her menü için ayrı state'ler
  const [whatsappLogs, setWhatsappLogs] = useState({ logs: [], stats: {}, loading: false });
  const [opencartApi, setOpencartApi] = useState({ 
    licenses: [], 
    sites: [], 
    loading: false,
    showCreateLicense: false,
    newLicenseData: {
      site_url: ''
    }
  });
  const [cargoApi, setCargoApi] = useState({
    settings: [],
    trackings: [],
    loading: false,
    selectedCompany: 'yurtici',
    selectedCompanyForDetails: null, // Hangi kargo şirketinin detayları görünecek
    apiForm: {
      api_username: '',
      api_password: '',
      api_url: 'https://ws.yurticikargo.com/KOPSWebServices/ShippingOrderDispatcherServices?wsdl'
    },
    messageTemplates: {
      yurtici: {
        created: 'Merhaba [musteri-adi]! Kargonuz toplandı ve Yurtiçi Kargo ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz teslimattadır ve yüklendi. Size doğru geliyor.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz teslimattadır ve şubeye ulaştı.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz çıkışı engellendi, lütfen şube ile iletişime geçin.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz teslim edilmiştir. İyi günler dileriz!'
      },
      ptt: {
        created: 'Merhaba [musteri-adi]! Kargonuz PTT Kargo ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      aras: {
        created: 'Merhaba [musteri-adi]! Kargonuz Aras Kargo ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      suret: {
        created: 'Merhaba [musteri-adi]! Kargonuz Sürat Kargo ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      mng: {
        created: 'Merhaba [musteri-adi]! Kargonuz MNG Kargo ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      hepsijet: {
        created: 'Merhaba [musteri-adi]! Kargonuz Hepsijet ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      trendyol: {
        created: 'Merhaba [musteri-adi]! Kargonuz Trendyol Express ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      ups: {
        created: 'Merhaba [musteri-adi]! Kargonuz UPS Türkiye ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      dhl: {
        created: 'Merhaba [musteri-adi]! Kargonuz DHL ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      },
      kolay: {
        created: 'Merhaba [musteri-adi]! Kargonuz Kolay Gelsin ile [takip-no] takip numarası ile gönderilmiştir.',
        transfer: 'Merhaba [musteri-adi]! Kargonuz şubeler arası aktarılmaktadır.',
        arrived: 'Merhaba [musteri-adi]! Kargonuz şubeye ulaşmıştır.',
        waiting: 'Merhaba [musteri-adi]! Kargonuz şubede bekletilmektedir.',
        returning: 'Merhaba [musteri-adi]! Kargonuz iade edilmektedir.',
        cancelled: 'Merhaba [musteri-adi]! Kargonuz iptal edilmiştir.',
        delivered: 'Merhaba [musteri-adi]! Kargonuz başarıyla teslim edilmiştir.'
      }
    }
  });

  const [firmFeatures, setFirmFeatures] = useState({
    bulk_message_enabled: false,
    api_enabled: false
  });

  // Menü öğeleri (feature flag'lere göre dinamik)
  const menuItems = useMemo(() => {
    const items = [
      { id: 'dashboard', name: 'Anasayfa', icon: 'fas fa-home' },
      { id: 'whatsapp-logs', name: 'WhatsApp Logları', icon: 'fas fa-comments' },
      { id: 'webhook-integrations', name: 'Webhook Entegrasyonlar', icon: 'fas fa-plug' },
      { id: 'whatsapp-templates', name: 'Mesaj Şablonları', icon: 'fas fa-file-alt' },
      { id: 'module-settings', name: 'Modül Ayarları', icon: 'fas fa-sliders-h' }
    ];

    if (firmFeatures.bulk_message_enabled) {
      items.push({ id: 'bulk-message', name: 'Toplu Mesaj', icon: 'fas fa-bullhorn' });
    }

    if (firmFeatures.api_enabled) {
      items.push({ id: 'opencart-api', name: 'OpenCart API', icon: 'fas fa-rocket' });
    }

    items.push({ id: 'cargo-api', name: 'Kargo API', icon: 'fas fa-shipping-fast' });

    return items;
  }, [firmFeatures.bulk_message_enabled, firmFeatures.api_enabled]);

  // Check if mobile
  const MOBILE_BREAKPOINT = 1200;

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobile, isMobileMenuOpen]);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Authentication kontrolü ve title ayarla
  useEffect(() => {
    // Tarayıcı title'ını ayarla
    document.title = 'FBAJANS WhatsApp Business - Panel';
    
    const token = sessionStorage.getItem('authToken');
    const userRole = sessionStorage.getItem('userRole');
    
    if (!token) {
      navigate('/');
      return;
    }
    
    // Admin ise admin paneline yönlendir
    if (userRole === 'admin') {
      navigate('/admin');
      return;
    }
  }, [navigate]);

  // Firm slug'ı localStorage'dan al
  useEffect(() => {
    const storedFirmSlug = sessionStorage.getItem('firmSlug');
    const storedUsername = sessionStorage.getItem('username');
    
    if (storedFirmSlug) {
      setFirmSlug(storedFirmSlug);
    } else if (storedUsername) {
      setFirmSlug(storedUsername);
    }
  }, []);

  // Firma feature flag'lerini yükle
  useEffect(() => {
    const loadFeatures = async () => {
      if (!firmSlug) return;
      try {
        const res = await fetch(`/api/firms/${firmSlug}/features`);
        const data = await res.json();
        if (data?.success && data?.data) {
          setFirmFeatures({
            bulk_message_enabled: !!data.data.bulk_message_enabled,
            api_enabled: !!data.data.api_enabled
          });
        }
      } catch (e) {
        // Feature fetch başarısızsa menüde göstermeyelim (fail-closed)
        setFirmFeatures({ bulk_message_enabled: false, api_enabled: false });
      }
    };
    loadFeatures();
  }, [firmSlug]);

  // Panel notifications (unread banner)
  useEffect(() => {
    const loadNotifications = async () => {
      if (!firmSlug) return;
      setPanelNotificationsLoading(true);
      try {
        const res = await fetch(`/api/firms/${firmSlug}/notifications?unread=1&limit=1&offset=0`, {
          headers: { 'x-firm-slug': firmSlug }
        });
        const data = await res.json();
        if (data?.success) {
          setPanelNotifications({
            unread_total: data.data?.unread_total || 0,
            items: data.data?.items || []
          });
        }
      } catch {
        // ignore
      } finally {
        setPanelNotificationsLoading(false);
      }
    };

    loadNotifications();
    // Polling every minute can add load on busy days (2 DB queries per poll).
    // 5 minutes is enough for a warning banner.
    const t = setInterval(loadNotifications, 300_000);
    return () => clearInterval(t);
  }, [firmSlug]);

  // Logo mesajını backend'den çek
  useEffect(() => {
    const fetchLogoMessage = async () => {
      try {
        const response = await fetch('/api/admin/settings');
        const data = await response.json();
        if (data.success && data.data.logo_message) {
          setLogoMessage(data.data.logo_message);
        }
        if (data.success && data.data.logo_file) {
          setLogoFile(data.data.logo_file);
        }
      } catch (error) {
        console.error('Logo mesajı çekilemedi:', error);
      }
    };

    fetchLogoMessage();
  }, []);

  // API fonksiyonları
  const checkConnectionStatus = async () => {
    if (!firmSlug) return;
    setLoading(true);
    try {
      // Backend API endpoint'ini kullan
      const response = await fetch(`/api/whatsapp-service/status/${firmSlug}`);
      const data = await response.json();
      
      console.log('🔍 Status response:', data);
      console.log('🔍 data.data:', data.data);
      console.log('🔍 live_status:', data.data?.data?.status);
      console.log('🔍 data.success:', data.success);
      console.log('🔍 data.data exists:', !!data.data);
      
      if (data.success && data.data && data.data.data && data.data.data.status) {
        setConnectionStatus(data.data.data.status);
        setLastCheck(new Date());
        
        if (data.data.data.status === 'connected') {
          setSuccessMessage('✅ WhatsApp bağlantısı aktif!');
          setError('');
        } else if (data.data.data.status === 'qr_waiting') {
          setError('📱 QR kod bekliyor - WhatsApp uygulamanızla tarayın');
          setSuccessMessage('');
        } else if (data.data.data.status === 'not_initialized') {
          setError('📱 WhatsApp başlatılmamış - "QR için Hazırla" butonuna tıklayın');
          setSuccessMessage('');
        } else if (data.data.data.status === 'authenticated') {
          setSuccessMessage('✅ WhatsApp bağlantısı aktif!');
          setError('');
        } else {
          setError(`📱 WhatsApp durumu: ${data.data.data.status}`);
          setSuccessMessage('');
        }
      } else {
        setConnectionStatus('not_connected');
        setError('📱 WhatsApp bağlı değil - Bağlanmak için "WhatsApp Durumu Yenile" butonuna tıklayın');
      }
    } catch (error) {
      console.error('WhatsApp status check error:', error);
      setConnectionStatus('not_connected');
      setError('📱 WhatsApp bağlantısı kontrol edilemedi - "WhatsApp Durumu Yenile" butonuna tıklayın');
    }
    setLoading(false);
  };

  // QR için WhatsApp'ı hazırla
  const prepareWhatsAppForQR = async () => {
    if (!firmSlug) return;
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔧 WhatsApp QR hazırlama başlatılıyor...');
      
      const response = await fetch(`/api/whatsapp-service/qr/${firmSlug}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        console.log('✅ WhatsApp QR hazırlama başarılı:', data);
        setSuccessMessage('🔧 WhatsApp QR için hazırlanıyor...');
        setConnectionStatus('initializing');
        
        // 3 saniye sonra durumu kontrol et
        setTimeout(() => {
          checkConnectionStatus();
        }, 3000);
        
      } else {
        console.error('❌ WhatsApp QR hazırlama hatası:', data.error);
        setError('WhatsApp hazırlanamadı: ' + data.error);
      }
      
    } catch (error) {
      console.error('❌ WhatsApp QR hazırlama hatası:', error);
      setError('WhatsApp hazırlama hatası: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // QR kodu göster
  const showQRCode = async () => {
    if (!firmSlug) return;
    try {
      setLoading(true);
      setError(null);
      
      console.log('📱 QR kod isteniyor...');
      
      const response = await fetch(`/api/whatsapp-service/qr/${firmSlug}`);
      const data = await response.json();
      
      if (data.success && data.data.qr_code) {
        console.log('✅ QR kod alındı');
        setQrCode(data.data.qr_code);
        setSuccessMessage('📱 QR kod hazır! Telefonunuzla tarayın.');
        setError('');
        setConnectionStatus('qr_waiting');
      } else {
        console.error('❌ QR kod alınamadı:', data.error);
        setError('QR kod alınamadı: ' + (data.error || 'Bilinmeyen hata'));
      }
      
    } catch (error) {
      console.error('❌ QR kod hatası:', error);
      setError('QR kod hatası: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const startWhatsAppConnection = async () => {
    if (!firmSlug) return;
    setLoading(true);
    try {
      // QR kodu talep ederek bağlantıyı başlat
      // Backend API endpoint'ini kullan
      const response = await fetch(`/api/whatsapp-service/qr/${firmSlug}`);
      const data = await response.json();
      
      if (data.success) {
        setSuccessMessage('🚀 WhatsApp bağlantısı başlatıldı! QR kodunu tarayın.');
        setError('');
        setConnectionStatus('qr_waiting');
        // QR sayfasını aç
        openQRPage();
      } else {
        setError('❌ WhatsApp bağlantısı başlatılamadı: ' + (data.message || 'Bilinmeyen hata'));
        setSuccessMessage('');
      }
    } catch (error) {
      setError('❌ WhatsApp bağlantısı başlatılamadı');
      setSuccessMessage('');
    }
    setLoading(false);
  };

  const fetchStats = async () => {
    if (!firmSlug) return;
    try {
      // Node.js backend'den veri al
      const response = await fetch(`https://panel.fbajans.com/api/firms/${firmSlug}/stats`);
      const data = await response.json();
      console.log('🔍 fetchStats response:', data);
      if (data.success) {
        const statsData = {
          tokenBalance: data.data.token_balance || 0,
          message_limit: data.data.message_limit || 0,
          messages_sent: data.data.messages_sent || 0,
          firmName: data.data.firm_name || firmSlug,
          remaining_days: data.data.remaining_days || 0,
          license_start_date: data.data.license_start_date || null,
          license_end_date: data.data.license_end_date || null,
          gptTodayMessages: data.data.gpt_today_messages || 0,
          gptTodayTokens: data.data.gpt_today_tokens || 0
        };
        console.log('📊 setStats data:', statsData);
        setStats(statsData);
      }
    } catch (error) {
      console.error('İstatistik hatası:', error);
      // Test verisi kullan
      setStats({
        tokenBalance: 100,
        message_limit: 1000,
        messages_sent: 0,
        firmName: firmSlug,
        remaining_days: 30,
        license_start_date: '2024-01-01',
        license_end_date: '2024-12-31',
        gptTodayMessages: 0,
        gptTodayTokens: 0
      });
    }
  };

  const fetchWhatsAppLogs = async () => {
    if (!firmSlug) return;
    setWhatsappLogs(prev => ({ ...prev, loading: true }));
    try {
      const response = await fetch(`https://panel.fbajans.com/api/firms/${firmSlug}/logs`);
      const data = await response.json();
      if (data.success) {
        setWhatsappLogs({ 
          logs: data.data.logs, 
          stats: {
            total: data.data.stats.total_messages || 0,
            today: data.data.stats.sent_messages || 0
          }, 
          loading: false 
        });
        console.log('📱 WhatsApp logları yüklendi:', data.data.logs.length, 'mesaj');
      } else {
        console.error('❌ WhatsApp logları yüklenemedi:', data.message);
        setWhatsappLogs(prev => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error('❌ WhatsApp logları yükleme hatası:', error);
      setWhatsappLogs(prev => ({ ...prev, loading: false }));
    }
  };



  // OpenCart API fonksiyonları
  const createLicenseKey = async () => {
    if (!firmSlug) return;
    
    setOpencartApi(prev => ({ ...prev, loading: true }));
    try {
      const response = await fetch('/api/licenses/generate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firm_slug: firmSlug
          // 1 Firma = 1 Lisans = 1 Site (backend otomatik kontrol eder)
        })
      });

      const data = await response.json();
      
      if (data.success) {
        // Lisans key oluşturuldu, listeyi yenile
        fetchOpencartLicenses();
        setOpencartApi(prev => ({ 
          ...prev, 
          showCreateLicense: false,
          newLicenseData: { site_url: '' }
        }));
        window.alert('✅ Lisans key başarıyla oluşturuldu!\n\n📝 Şimdi bu lisans key\'i OpenCart sitenize kurun. Site otomatik olarak tespit edilecek!');
      } else {
        window.alert('❌ Lisans key oluşturulamadı: ' + (data.error || 'Bilinmeyen hata'));
      }
          } catch (error) {
        window.alert('❌ Hata: ' + error.message);
      } finally {
        setOpencartApi(prev => ({ ...prev, loading: false }));
      }
    };
    
    const fetchOpencartLicenses = async () => {
    if (!firmSlug) return;
    
    setOpencartApi(prev => ({ ...prev, loading: true }));
    try {
      const response = await fetch(`/api/licenses/${firmSlug}`);
      const data = await response.json();
      
      if (data.success) {
        // Backend tek lisans döndürüyor, array'e çevir
        const licenseData = data.data.license;
        const siteData = data.data.site;
        
        setOpencartApi(prev => ({ 
          ...prev, 
          licenses: licenseData ? [licenseData] : [],
          sites: siteData ? [siteData] : [],
          loading: false 
        }));
      }
    } catch (error) {
      console.error('Lisans bilgileri çekilemedi:', error);
      setOpencartApi(prev => ({ ...prev, loading: false }));
    }
  };

  const deleteLicense = async (licenseId) => {
    if (!firmSlug || !licenseId) return;
    
    if (!window.confirm('⚠️ Bu lisans key\'i silmek istediğinizden emin misiniz?\n\nBu işlem geri alınamaz!')) {
      return;
    }
    
    setOpencartApi(prev => ({ ...prev, loading: true }));
    try {
      const response = await fetch(`/api/licenses/${licenseId}`, {
        method: 'DELETE'
      });
      
      const data = await response.json();
      
      if (data.success) {
        window.alert('✅ Lisans key başarıyla silindi!');
        // Lisans listesini yenile
        fetchOpencartLicenses();
      } else {
        window.alert('❌ Lisans key silinemedi: ' + (data.error || 'Bilinmeyen hata'));
      }
    } catch (error) {
      window.alert('❌ Hata: ' + error.message);
    } finally {
      setOpencartApi(prev => ({ ...prev, loading: false }));
    }
  };

  // Kargo API fonksiyonları
  const fetchCargoSettings = async () => {
    if (!firmSlug) return;
    
    setCargoApi(prev => ({ ...prev, loading: true }));
    try {
      const response = await fetch(`/api/firms/${firmSlug}/cargo-settings`);
      const data = await response.json();
      
      if (data.success) {
        setCargoApi(prev => ({ 
          ...prev, 
          settings: data.settings,
          loading: false 
        }));
        
        // Mevcut ayarları forma yükle
        if (data.settings.length > 0) {
          const yurticiSetting = data.settings.find(s => s.cargo_company === 'yurtici');
          if (yurticiSetting) {
            setCargoApi(prev => ({
              ...prev,
              apiForm: {
                api_username: yurticiSetting.api_username || '',
                api_password: yurticiSetting.api_password || '',
                api_url: yurticiSetting.api_url || 'https://ws.yurticikargo.com/KOPSWebServices/ShippingOrderDispatcherServices?wsdl'
              }
            }));
          }
        }
      } else {
        console.error('Kargo ayarları yüklenemedi:', data.error);
      }
    } catch (error) {
      console.error('Kargo ayarları yükleme hatası:', error);
    } finally {
      setCargoApi(prev => ({ ...prev, loading: false }));
    }
  };

  const saveCargoSettings = async () => {
    if (!firmSlug) return;
    
    setCargoApi(prev => ({ ...prev, loading: true }));
    try {
      const response = await fetch(`/api/firms/${firmSlug}/cargo-settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cargo_company: cargoApi.selectedCompany,
          api_username: cargoApi.apiForm.api_username,
          api_password: cargoApi.apiForm.api_password,
          api_url: cargoApi.apiForm.api_url
        })
      });

      const data = await response.json();
      
      if (data.success) {
        alert('Kargo ayarları kaydedildi!');
        fetchCargoSettings();
      } else {
        alert('Hata: ' + data.error);
      }
    } catch (error) {
      console.error('Kargo ayarları kaydetme hatası:', error);
      alert('Ayarlar kaydedilirken hata oluştu');
    } finally {
      setCargoApi(prev => ({ ...prev, loading: false }));
    }
  };

  const testCargoConnection = async () => {
    if (!firmSlug) return;
    
    setCargoApi(prev => ({ ...prev, loading: true }));
    try {
      const response = await fetch(`/api/firms/${firmSlug}/cargo-test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cargo_company: cargoApi.selectedCompany,
          api_username: cargoApi.apiForm.api_username,
          api_password: cargoApi.apiForm.api_password
        })
      });

      const data = await response.json();
      
      if (data.success) {
        alert('✅ ' + data.message);
      } else {
        alert('❌ ' + data.message);
      }
    } catch (error) {
      console.error('Kargo test hatası:', error);
      alert('Test bağlantısı yapılırken hata oluştu');
    } finally {
      setCargoApi(prev => ({ ...prev, loading: false }));
    }
  };


  const fetchCargoTracking = async () => {
    if (!firmSlug) return;
    
    try {
      const response = await fetch(`/api/firms/${firmSlug}/cargo-tracking`);
      const data = await response.json();
      
      if (data.success) {
        setCargoApi(prev => ({ 
          ...prev, 
          trackings: data.trackings
        }));
      }
    } catch (error) {
      console.error('Kargo takip listesi yükleme hatası:', error);
    }
  };


  // Sayfa yüklendiğinde
  useEffect(() => {
    if (firmSlug) {
      checkConnectionStatus();
      fetchStats();
    }
  }, [firmSlug]);

  // WhatsApp logları sekmesi görünür olduğunda logları yükle
  useEffect(() => {
    if (activeTab === 'whatsapp-logs-detail' && firmSlug) {
      fetchWhatsAppLogs();
    }
  }, [activeTab, firmSlug]);

  // OpenCart API sekmesi açıldığında lisans bilgilerini yükle
  useEffect(() => {
    if (activeTab === 'opencart-api' && firmSlug && firmFeatures.api_enabled) {
      fetchOpencartLicenses();
    }
  }, [activeTab, firmSlug, firmFeatures.api_enabled]);

  // Kargo API sekmesi açıldığında ayarları yükle
  useEffect(() => {
    if (activeTab === 'cargo-api' && firmSlug) {
      fetchCargoSettings();
      fetchCargoTracking();
    }
  }, [activeTab, firmSlug]);

  const openQRPage = () => {
    if (firmSlug) {
      window.open(`/qr/${firmSlug}`, '_blank');
    }
  };

  const handleLogout = () => {
    // Tüm authentication bilgilerini temizle
    localStorage.clear();
    sessionStorage.clear();
    
    // Sayfayı yenile ve login sayfasına yönlendir
    window.location.href = '/';
  };

  const handleMenuClick = (tabId) => {
    // URL sabit kalsın, Dashboard içinde sekme değiştir
    if (tabId === 'whatsapp-logs') {
      setActiveTab('whatsapp-logs-detail');
    } else {
      if (window.location.pathname !== '/dashboard') {
        navigate('/dashboard', { replace: true });
      }
      setActiveTab(tabId);
    }
    if (isMobile) setIsMobileMenuOpen(false);
  };

  const getStatusBadge = () => {
    switch (connectionStatus) {
      case 'connected':
        return { color: '#28a745', bgColor: '#d4edda', icon: '🟢', text: 'Bağlı' };
      case 'not_initialized':
        return { color: '#6c757d', bgColor: '#f8f9fa', icon: '⚪', text: 'Başlatılmamış' };
      case 'qr_waiting':
        return { color: '#ffc107', bgColor: '#fff3cd', icon: '🟡', text: 'QR Bekliyor' };
      default:
        return { color: '#dc3545', bgColor: '#f8d7da', icon: '❌', text: 'Hata' };
    }
  };

  const statusBadge = getStatusBadge();

  // Mobile Sidebar Component
  const MobileSidebar = () => (
    <>
      {/* Overlay */}
      {isMobileMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1998,
            transition: 'opacity 0.3s ease'
          }}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: isMobileMenuOpen ? 0 : '-280px',
          width: '280px',
          height: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          zIndex: 1999,
          transition: 'left 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)'
        }}
      >
        {/* Sidebar Header */}
        <div style={{
          padding: '20px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              FB
            </div>
            <div>
              <div style={{ fontWeight: 'bold', color: 'white', fontSize: '16px' }}>FBAJANS</div>
              <div style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.8)' }}>{stats.firmName || firmSlug}</div>
            </div>
          </div>
          
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '5px'
            }}
          >
            ×
          </button>
        </div>

        {/* Menu Items */}
        <div style={{ flex: 1, padding: '20px 0' }}>
          {menuItems.map(item => {
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => handleMenuClick(item.id)}
                style={{
                  width: '100%',
                  padding: '15px 20px',
                  border: 'none',
                  background: isActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  fontSize: '16px',
                  fontWeight: isActive ? '600' : '500',
                  transition: 'all 0.2s ease',
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.target.style.background = 'transparent';
                  }
                }}
              >
                <i className={item.icon} style={{ fontSize: '18px', marginRight: '8px' }}></i>
                <span>{item.name}</span>
              </button>
            );
          })}
        </div>

        {/* Action Buttons */}
        <div style={{ padding: '20px', borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}>
          <button
            onClick={async () => {
              try {
                const response = await fetch('/api/admin/settings');
                const data = await response.json();
                if (data.success && data.data.membership_agreement_message) {
                  setAgreementContent(data.data.membership_agreement_message);
                  setAgreementType('membership');
                  setShowAgreementModal(true);
                }
              } catch (error) {
                console.error('Sözleşme yüklenemedi:', error);
              }
            }}
            style={{
              width: '100%',
              padding: '12px',
              border: 'none',
              background: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              marginBottom: '10px'
            }}
          >
            <i className="fas fa-file-contract"></i>
            <span>Hizmet Sözleşmesi</span>
          </button>
          
          <button
            onClick={async () => {
              try {
                const response = await fetch('/api/admin/settings');
                const data = await response.json();
                if (data.success && data.data.privacy_policy_message) {
                  setAgreementContent(data.data.privacy_policy_message);
                  setAgreementType('privacy');
                  setShowAgreementModal(true);
                }
              } catch (error) {
                console.error('Gizlilik sözleşmesi yüklenemedi:', error);
              }
            }}
            style={{
              width: '100%',
              padding: '12px',
              border: 'none',
              background: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              marginBottom: '10px'
            }}
          >
            <i className="fas fa-shield-alt"></i>
            <span>Gizlilik Politikası</span>
          </button>
          
          <button
            onClick={() => navigate('/change-password')}
            style={{
              width: '100%',
              padding: '12px',
              border: 'none',
              background: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              marginBottom: '10px'
            }}
          >
            <i className="fas fa-key"></i>
            <span>Şifre Değiştir</span>
          </button>
          
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '12px',
              border: 'none',
              background: '#dc3545',
              color: 'white',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            <i className="fas fa-sign-out-alt"></i>
            <span>Çıkış Yap</span>
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: isMobile ? '10px' : '20px',
      overflowX: 'hidden'
    }}>
      {/* Mobile Sidebar */}
      {isMobile && <MobileSidebar />}

      {/* Header */}
      <div style={{
        background: 'white',
        borderRadius: isMobile ? '12px' : '15px',
        padding: isMobile ? '15px' : '20px',
        marginBottom: isMobile ? '15px' : '20px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        {/* Mobile Menu Button & Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {isMobile && (
            <button
              onClick={() => setIsMobileMenuOpen(true)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                padding: '5px',
                color: '#333'
              }}
            >
              ☰
            </button>
          )}
          
          <div>
              <div style={{ textAlign: 'center' }}>
                <img 
                src={logoFile ? `/api/logo/${logoFile}` : "/logo.png"} 
                alt="FBAJANS Logo" 
                  style={{ 
                    maxHeight: '40px', 
                    width: 'auto'
                  }} 
                />
              </div>
          </div>
        </div>

        {/* Desktop Action Buttons */}
        {!isMobile && (
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <button
              onClick={() => navigate('/change-password')}
              style={{
                background: '#ffc107',
                color: '#212529',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              <i className="fas fa-key" style={{ marginRight: '8px' }}></i>
              Şifre Değiştir
            </button>
            <button
              onClick={handleLogout}
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              <i className="fas fa-sign-out-alt" style={{ marginRight: '8px' }}></i>
              Çıkış
            </button>
          </div>
        )}

        {/* Mobile Logout Button */}
        {isMobile && (
          <button
            onClick={handleLogout}
            style={{
              padding: '8px',
              border: 'none',
              background: '#dc3545',
              color: 'white',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            <i className="fas fa-sign-out-alt"></i>
          </button>
        )}
      </div>

      {/* Desktop Navigation Menu */}
      {!isMobile && (
        <div style={{
          background: 'white',
          borderRadius: '15px',
          padding: '15px',
          marginBottom: '20px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
          display: 'flex',
          overflowX: 'auto',
          gap: '10px',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleMenuClick(item.id)}
              style={{
                background: activeTab === item.id ? '#007bff' : 'transparent',
                color: activeTab === item.id ? 'white' : '#333',
                border: activeTab === item.id ? 'none' : '2px solid #e9ecef',
                padding: '12px 20px',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                transition: 'all 0.3s ease'
              }}
            >
              {item.name}
            </button>
          ))}
        </div>
      )}

      {/* Mobile Active Tab Indicator */}
      {isMobile && (
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '15px',
          marginBottom: '15px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
          textAlign: 'center',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <h2 style={{ margin: 0, color: '#007bff', fontSize: '18px' }}>
            {menuItems.find(item => item.id === activeTab)?.name || 'Dashboard'}
          </h2>
        </div>
      )}

      {/* Content Area */}
      {activeTab === 'dashboard' && (
        <div>
          {error && (
            <div style={{
              background: '#f8d7da',
              color: '#721c24',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '20px'
            }}>
              {error}
            </div>
          )}

          {successMessage && (
            <div style={{
              background: '#d4edda',
              color: '#155724',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '20px'
            }}>
              {successMessage}
            </div>
          )}

          {/* Panel Notifications Banner */}
          {panelNotifications?.unread_total > 0 && (
            <div style={{
              background: '#fff3cd',
              color: '#856404',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '20px',
              border: '1px solid #ffeeba'
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ fontSize: '18px', marginTop: '2px' }}>
                  <i className="fas fa-exclamation-triangle"></i>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                    {panelNotifications.items?.[0]?.title || 'Bildirim'}
                    <span style={{ fontWeight: 'normal', marginLeft: '8px', fontSize: '12px', opacity: 0.8 }}>
                      ({panelNotifications.unread_total} okunmamış)
                    </span>
                  </div>
                  <div style={{ whiteSpace: 'pre-wrap' }}>
                    {panelNotifications.items?.[0]?.message || ''}
                  </div>
                </div>
                <button
                  disabled={panelNotificationsLoading || !panelNotifications.items?.[0]?.id}
                  onClick={async () => {
                    const id = panelNotifications.items?.[0]?.id;
                    if (!id) return;
                    try {
                      await fetch(`/api/firms/${firmSlug}/notifications/${id}/read`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'x-firm-slug': firmSlug }
                      });
                    } catch {
                      // ignore
                    }
                    // optimistic refresh
                    setPanelNotifications({ unread_total: 0, items: [] });
                  }}
                  style={{
                    background: '#856404',
                    color: 'white',
                    border: 'none',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Okudum
                </button>
              </div>
            </div>
          )}

          {/* WhatsApp Durum Paneli */}
          {firmSlug && <WhatsAppStatusPanel slug={firmSlug} stats={stats} />}



        </div>
      )}

      {/* WhatsApp Logları */}
      {/* WhatsApp Logları sekmesi, doğrudan /whatsapp-logs rotasına yönlendirildi */}

      {/* WhatsApp Logları Detay */}
      {activeTab === 'whatsapp-logs-detail' && (
        <div style={{ background: 'white', borderRadius: '15px', padding: '30px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2>
              <i className="fas fa-comments" style={{ marginRight: '8px' }}></i>
              WhatsApp Logları
            </h2>
          <button
              onClick={() => setActiveTab('whatsapp-logs')}
            style={{
                background: '#6c757d',
              color: 'white',
              border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              ← Geri Dön
          </button>
        </div>

          <WhatsAppLogsContent />
        </div>
      )}



      {activeTab === 'opencart-api' && firmFeatures.api_enabled && (
        <div style={{ background: 'white', borderRadius: '15px', padding: '30px' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: isMobile ? 'flex-start' : 'space-between', 
            alignItems: isMobile ? 'flex-start' : 'center', 
            marginBottom: '20px',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '12px' : '0'
          }}>
            <h2>
              <i className="fas fa-rocket" style={{ marginRight: '8px' }}></i>
              OpenCart API Entegrasyonu
            </h2>
            <button
              onClick={() => setOpencartApi(prev => ({ ...prev, showCreateLicense: true }))}
              style={{
                background: '#28a745',
                color: 'white',
                border: 'none',
                padding: '10px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: isMobile ? '100%' : 'auto',
                justifyContent: 'center',
                fontWeight: '600'
              }}
            >
              <i className="fas fa-key"></i>
              Yeni Lisans Key Oluştur
            </button>
          </div>

          {/* Lisans Key Oluşturma Modal */}
          {opencartApi.showCreateLicense && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}>
              <div style={{
                background: 'white',
                borderRadius: '12px',
                padding: '30px',
                width: '500px',
                maxWidth: '90%'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#333' }}>🔑 Yeni Lisans Key Oluştur</h3>
                
                                  {/* Lisans Bilgileri */}
                  <div style={{ 
                    marginBottom: '20px', 
                    padding: '16px', 
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', 
                    borderRadius: '8px', 
                    border: '2px solid #dee2e6',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}>

                  <div style={{ 
                    marginBottom: '12px', 
                    textAlign: 'center', 
                    fontSize: '14px', 
                    fontWeight: 'bold', 
                    color: '#495057' 
                  }}>
                      <i className="fas fa-chart-bar" style={{ marginRight: '8px' }}></i>
                      Lisans Durumu
                    </div>
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', 
                    gap: '15px', 
                    fontSize: '13px',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      padding: '8px',
                      background: 'white',
                      borderRadius: '6px',
                      border: '1px solid #28a745'
                    }}>
                      <div style={{ fontWeight: 'bold', color: '#495057', marginBottom: '4px' }}>
                        <i className="fas fa-check-circle" style={{ marginRight: '8px' }}></i>
                        Mevcut Lisans
                      </div>
                      <div style={{ fontSize: '18px', color: '#28a745', fontWeight: 'bold' }}>
                        {opencartApi.licenses.length}
                      </div>
                    </div>
                    <div style={{
                      padding: '8px',
                      background: 'white',
                      borderRadius: '6px',
                      border: '1px solid #17a2b8'
                    }}>
                      <div style={{ fontWeight: 'bold', color: '#495057', marginBottom: '4px' }}>
                        <i className="fas fa-bullseye" style={{ marginRight: '8px' }}></i>
                        Lisans Durumu
                      </div>
                      <div style={{ fontSize: '18px', color: '#17a2b8', fontWeight: 'bold' }}>
                        {opencartApi.licenses.length > 0 ? (
                          <>
                            <i className="fas fa-check-circle" style={{ marginRight: '4px' }}></i>
                            Aktif
                          </>
                        ) : (
                          <>
                            <i className="fas fa-times-circle" style={{ marginRight: '4px' }}></i>
                            Yok
                          </>
                        )}
                      </div>
                    </div>
                    <div style={{
                      padding: '8px',
                      background: 'white',
                      borderRadius: '6px',
                      border: '1px solid #6c757d'
                    }}>
                      <div style={{ fontWeight: 'bold', color: '#495057', marginBottom: '4px' }}>
                        <i className="fas fa-trophy" style={{ marginRight: '8px' }}></i>
                        Sistem
                      </div>
                      <div style={{ fontSize: '14px', color: '#6c757d', fontWeight: 'bold' }}>
                        1 Lisans = 1 Site
                      </div>
                    </div>
                  </div>
                    <div style={{ 
                      marginTop: '12px', 
                      fontSize: '12px', 
                      color: '#6c757d', 
                      textAlign: 'center',
                      fontStyle: 'italic',
                      padding: '8px',
                      background: 'rgba(255,255,255,0.7)',
                      borderRadius: '4px'
                    }}>
                    Her firma yalnızca tek bir OpenCart sitesi bağlayabilir.
                  </div>
                </div>

                <div style={{ marginBottom: '15px' }}>
                  <div style={{ 
                    padding: '15px', 
                    background: 'linear-gradient(135deg, #e7f3ff 0%, #d1ecf1 100%)', 
                    border: '2px solid #b3d9ff', 
                    borderRadius: '8px',
                    fontSize: '14px',
                    color: '#0066cc',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '16px', marginBottom: '8px' }}>ℹ️ <strong>Otomatik Site Tespiti</strong></div>
                    <div>Site adı girmenize gerek yok! OpenCart modülü ilk istekte otomatik olarak site bilgisini bildirecek.</div>
                    <div style={{ marginTop: '8px', fontSize: '12px', color: '#0056b3' }}>
                      🔒 Lisans key'i alıp OpenCart sitenize kurduğunuzda site otomatik tespit edilecek
                    </div>
                  </div>
                </div>



                <div style={{ display: 'flex', gap: '10px' }}>
                  <button
                    onClick={() => setOpencartApi(prev => ({ ...prev, showCreateLicense: false }))}
                    style={{
                      flex: 1,
                      background: '#6c757d',
                      color: 'white',
                      border: 'none',
                      padding: '12px',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    İptal
                  </button>
                  <button
                    onClick={createLicenseKey}
                    disabled={opencartApi.loading}
                    style={{
                      flex: 1,
                      background: '#28a745',
                      color: 'white',
                      border: 'none',
                      padding: '12px',
                      borderRadius: '6px',
                      cursor: opencartApi.loading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {opencartApi.loading ? (
                      <>
                        <i className="fas fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                        Oluşturuluyor...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-key" style={{ marginRight: '6px' }}></i>
                        Lisans Key Oluştur
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Mevcut Lisanslar */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ marginBottom: '15px', color: '#495057' }}>🔑 Mevcut Lisanslar</h3>
            {opencartApi.licenses.length > 0 ? (
              <div style={{ display: 'grid', gap: '15px' }}>
                {opencartApi.licenses.map((license, index) => (
                  <div key={index} style={{
                    border: '1px solid #e9ecef',
                    borderRadius: '8px',
                    padding: '20px',
                    background: '#f8f9fa'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                      <strong style={{ fontFamily: 'monospace', fontSize: '14px' }}>
                        {license.license_key}
                      </strong>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{
                          background: license.status === 'active' ? '#28a745' : '#dc3545',
                          color: 'white',
                          padding: '4px 8px',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: 'bold'
                        }}>
                          {license.license_status === 'active' ? '✅ Aktif' : '❌ Pasif'}
                        </span>
                        <button
                          onClick={() => deleteLicense(license.id)}
                          disabled={opencartApi.loading}
                          style={{
                            background: '#dc3545',
                            color: 'white',
                            border: 'none',
                            padding: '4px 8px',
                            borderRadius: '6px',
                            cursor: opencartApi.loading ? 'not-allowed' : 'pointer',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}
                          title="Lisans key'i sil"
                        >
                          <i className="fas fa-trash-alt" style={{ marginRight: '4px' }}></i>
                          Sil
                        </button>
                      </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', fontSize: '14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fas fa-globe" style={{ color: '#28a745' }}></i>
                        <span>Lisanslı Domain:</span>
                        {license.site_url ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <strong style={{ color: '#28a745' }}>{license.site_url}</strong>
                            <span style={{ 
                              background: '#28a745', 
                              color: 'white', 
                              padding: '2px 6px', 
                              borderRadius: '10px', 
                              fontSize: '10px',
                              fontWeight: 'bold'
                            }}>✅ Valid</span>
                          </div>
                        ) : (
                          <span style={{ color: '#dc3545', fontStyle: 'italic' }}>Aktif değil</span>
                        )}
                      </div>
                      <div><i className="fas fa-sms" style={{ marginRight: '6px', color: '#17a2b8' }}></i>Mesaj Kotası: <strong>{license.total_messages || 0} / {license.firm_message_limit}</strong></div>
                      <div><i className="fas fa-hourglass-half" style={{ marginRight: '6px', color: '#fd7e14' }}></i>Bitiş: <strong>{license.firm_license_expire ? new Date(license.firm_license_expire).toLocaleDateString('tr-TR') : 'Firma lisansına göre'}</strong></div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
                <p>Henüz lisans key oluşturulmamış.</p>
                <p>Yukarıdaki butona tıklayarak ilk lisans key'inizi oluşturun.</p>
              </div>
            )}
          </div>

          {/* Bağlı Siteler */}
          <div>
            <h3 style={{ marginBottom: '15px', color: '#495057' }}>🌐 Bağlı Siteler</h3>
            {opencartApi.sites && opencartApi.sites.length > 0 ? (
              <div style={{ display: 'grid', gap: '15px' }}>
                {opencartApi.sites.map((site, index) => (
                  <div key={index} style={{
                    border: '1px solid #e9ecef',
                    borderRadius: '8px',
                    padding: '20px',
                    background: '#f8f9fa'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                      <strong style={{ fontSize: '16px', color: '#495057' }}>
                        {site.site_name || site.site_url || 'İsimsiz Site'}
                      </strong>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{
                          background: site.status === 'active' ? '#28a745' : '#dc3545',
                          color: 'white',
                          padding: '4px 8px',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: 'bold'
                        }}>
                          {site.site_status === 'active' ? '✅ Aktif' : '❌ Pasif'}
                        </span>
                        {site.whatsapp_status && (
                          <span style={{
                            background: site.whatsapp_status === 'connected' ? '#28a745' : '#ffc107',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}>
                            {site.whatsapp_status === 'connected' ? '📱 WhatsApp' : '⚠️ Bağlantı Yok'}
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', fontSize: '14px' }}>
                      <div><strong>URL:</strong> {site.site_url}</div>
                      <div><strong>Lisans Key:</strong> <span style={{ fontFamily: 'monospace', fontSize: '12px' }}>{site.license_key}</span></div>
                      <div><strong>Bağlantı:</strong> {site.firm_license_expire ? new Date(site.firm_license_expire).toLocaleDateString('tr-TR') : 'Bilinmiyor'}</div>
                      <div><strong>Son Aktivite:</strong> {site.firm_license_expire ? new Date(site.firm_license_expire).toLocaleDateString('tr-TR') : 'Bilinmiyor'}</div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
                <p>Henüz site bağlantısı bulunmuyor.</p>
                <p>Lisans key'lerinizi OpenCart sitelerine kurduğunuzda burada görünecek.</p>
              </div>
            )}
          </div>
        </div>
      )}


      {activeTab === 'webhook-integrations' && (
        <div style={{ background: 'white', borderRadius: '15px', padding: '30px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
            <h2 style={{ margin: 0 }}>
              <i className="fas fa-plug" style={{ marginRight: '8px' }}></i>
              Webhook Entegrasyonları
            </h2>
          </div>

          <WebhookIntegrationsPanel firmSlug={firmSlug} />
        </div>
      )}

      {activeTab === 'module-settings' && (
        <div style={{ background: 'white', borderRadius: '15px', padding: '30px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
            <h2 style={{ margin: 0 }}>
              <i className="fas fa-sliders-h" style={{ marginRight: '8px' }}></i>
              Modül Ayarları
            </h2>
          </div>

          <FirmSettingsPanel firmSlug={firmSlug} />
        </div>
      )}

      {activeTab === 'whatsapp-templates' && (
        <div style={{ background: 'white', borderRadius: '15px', padding: '30px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
            <h2 style={{ margin: 0 }}>
              <i className="fas fa-file-alt" style={{ marginRight: '8px' }}></i>
              Mesaj Şablonları
            </h2>
          </div>

          <WhatsAppTemplatesPanel firmSlug={firmSlug} />
        </div>
      )}

      {activeTab === 'bulk-message' && (
        <div style={{ background: 'white', borderRadius: '15px', padding: '30px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2>
              <i className="fas fa-bullhorn" style={{ marginRight: '8px' }}></i>
              Toplu Mesaj
            </h2>
          </div>

          {!firmFeatures.bulk_message_enabled ? (
            <div style={{
              background: '#f8d7da',
              color: '#721c24',
              padding: '15px',
              borderRadius: '10px'
            }}>
              Bu firmada Toplu Mesaj özelliği aktif değil.
            </div>
          ) : (
            <BulkMessagePanel firmSlug={firmSlug} />
          )}
        </div>
      )}


      {activeTab === 'cargo-api' && (
        <div style={{ 
          padding: '20px', 
          background: 'white', 
          borderRadius: '10px', 
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)' 
        }}>
          <div style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '10px', color: '#495057' }}>📦 Kargo API Ayarları</h2>
            <p style={{ color: '#6c757d', fontSize: '14px' }}>
              Kargo şirketlerinin API bilgilerini yapılandırın ve kargo takip sistemini aktifleştirin.
            </p>
          </div>

          {/* Kargo Şirketi Seçimi */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ marginBottom: '15px', color: '#495057' }}>🚚 Kargo Şirketi Seçin</h3>
            <div style={{ display: 'grid', gap: '15px', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
            {[
              { id: 'yurtici', name: 'Yurtiçi Kargo', logo: '🚛', color: '#e3f2fd', supported: true },
              { id: 'ptt', name: 'PTT Kargo', logo: '📮', color: '#fff3e0', supported: false },
              { id: 'aras', name: 'Aras Kargo', logo: '📦', color: '#f3e5f5', supported: false },
              { id: 'suret', name: 'Sürat Kargo', logo: '⚡', color: '#fce4ec', supported: false },
              { id: 'mng', name: 'MNG Kargo', logo: '🚚', color: '#e8f5e8', supported: false },
              { id: 'hepsijet', name: 'Hepsijet', logo: '🛍️', color: '#f0f8ff', supported: false },
              { id: 'trendyol', name: 'Trendyol Express', logo: '📱', color: '#fff0f5', supported: false },
              { id: 'ups', name: 'UPS Türkiye', logo: '🌍', color: '#f5f5dc', supported: false },
              { id: 'dhl', name: 'DHL', logo: '✈️', color: '#ffe4e1', supported: false },
              { id: 'kolay', name: 'Kolay Gelsin', logo: '🎯', color: '#f0fff0', supported: false }
            ].map((company) => (
                <div
                  key={company.id}
                  onClick={() => setCargoApi(prev => ({ 
                    ...prev, 
                    selectedCompany: company.id,
                    selectedCompanyForDetails: company.id
                  }))}
                  style={{
                    padding: '20px',
                    background: company.color,
                    border: `2px solid ${cargoApi.selectedCompany === company.id ? '#007bff' : '#e9ecef'}`,
                    borderRadius: '10px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    transform: cargoApi.selectedCompany === company.id ? 'translateY(-2px)' : 'translateY(0)',
                    boxShadow: cargoApi.selectedCompany === company.id ? '0 4px 15px rgba(0,0,0,0.1)' : 'none'
                  }}
                  onMouseEnter={(e) => {
                    if (cargoApi.selectedCompany !== company.id) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                      e.target.style.borderColor = '#007bff';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (cargoApi.selectedCompany !== company.id) {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = '#dee2e6';
                    }
                  }}
                >
                  <div style={{ fontSize: '32px', marginBottom: '10px' }}>{company.logo}</div>
                  <div style={{ fontWeight: 'bold', color: '#495057' }}>{company.name}</div>
                <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                  {company.id === 'yurtici' ? '✅ Destekleniyor' : 
                   company.id === 'ptt' ? '🔄 Geliştiriliyor' : '⏳ Yakında'}
                </div>
                </div>
              ))}
            </div>
          </div>

          {/* API Ayarları - Sadece seçili şirket için */}
          {cargoApi.selectedCompanyForDetails && (
          <div style={{ 
            border: '1px solid #e9ecef', 
            borderRadius: '10px', 
            padding: '25px',
            background: '#f8f9fa'
          }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <span style={{ fontSize: '24px', marginRight: '10px' }}>
              {cargoApi.selectedCompany === 'yurtici' ? '🚛' : 
               cargoApi.selectedCompany === 'ptt' ? '📮' : '📦'}
            </span>
            <h3 style={{ margin: 0, color: '#495057' }}>
              {cargoApi.selectedCompany === 'yurtici' ? 'Yurtiçi Kargo' :
               cargoApi.selectedCompany === 'ptt' ? 'PTT Kargo' : 'Kargo'} API Ayarları
            </h3>
          </div>

            <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#495057' }}>
                  API Kullanıcı Adı
                </label>
                <input
                  type="text"
                  value={cargoApi.apiForm.api_username}
                  onChange={(e) => setCargoApi(prev => ({
                    ...prev,
                    apiForm: { ...prev.apiForm, api_username: e.target.value }
                  }))}
                  placeholder={cargoApi.selectedCompany === 'yurtici' ? 'YKTEST (Test) / Gerçek kullanıcı adınız' :
                            cargoApi.selectedCompany === 'ptt' ? 'PTT API kullanıcı adı' : 'API kullanıcı adı'}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #ced4da',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#495057' }}>
                  API Şifresi
                </label>
                <input
                  type="password"
                  value={cargoApi.apiForm.api_password}
                  onChange={(e) => setCargoApi(prev => ({
                    ...prev,
                    apiForm: { ...prev.apiForm, api_password: e.target.value }
                  }))}
                  placeholder={cargoApi.selectedCompany === 'yurtici' ? 'YK (Test) / Gerçek şifreniz' :
                            cargoApi.selectedCompany === 'ptt' ? 'PTT API şifresi' : 'API şifresi'}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #ced4da',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>

            <div style={{ marginTop: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#495057' }}>
                API URL
              </label>
              <input
                type="text"
                value="https://ws.yurticikargo.com/KOPSWebServices/ShippingOrderDispatcherServices?wsdl"
                readOnly
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ced4da',
                  borderRadius: '6px',
                  fontSize: '14px',
                  background: '#e9ecef',
                  color: '#6c757d'
                }}
              />
            </div>

            <div style={{ marginTop: '25px', display: 'flex', gap: '15px' }}>
              <button
                onClick={testCargoConnection}
                disabled={cargoApi.loading}
                style={{
                  background: cargoApi.loading ? '#6c757d' : '#28a745',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  cursor: cargoApi.loading ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {cargoApi.loading ? '⏳ Test Ediliyor...' : '🧪 Test Bağlantısı'}
              </button>
              <button
                onClick={saveCargoSettings}
                disabled={cargoApi.loading}
                style={{
                  background: cargoApi.loading ? '#6c757d' : '#007bff',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  cursor: cargoApi.loading ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {cargoApi.loading ? '⏳ Kaydediliyor...' : '💾 Ayarları Kaydet'}
              </button>
            </div>
          </div>
          )}

        {/* Teslimat Hareketleri - Sadece seçili şirket için */}
        {cargoApi.selectedCompanyForDetails && (
        <div style={{ 
          marginTop: '30px',
          padding: '25px', 
          background: '#f8f9fa', 
          border: '1px solid #e9ecef', 
          borderRadius: '10px'
        }}>
          <h3 style={{ marginBottom: '20px', color: '#495057' }}>📋 Teslimat Hareketleri</h3>
          <p style={{ color: '#6c757d', fontSize: '14px', marginBottom: '20px' }}>
            Her kargo şirketi için teslimat durumlarına göre müşterilere gönderilecek mesaj şablonlarını özelleştirin.
          </p>
          
          {(() => {
            const companies = {
              'yurtici': { id: 'yurtici', name: 'Yurtiçi Kargo', logo: '🚛' },
              'ptt': { id: 'ptt', name: 'PTT Kargo', logo: '📮' },
              'aras': { id: 'aras', name: 'Aras Kargo', logo: '📦' },
              'suret': { id: 'suret', name: 'Sürat Kargo', logo: '⚡' },
              'mng': { id: 'mng', name: 'MNG Kargo', logo: '🚚' },
              'hepsijet': { id: 'hepsijet', name: 'Hepsijet', logo: '🛍️' },
              'trendyol': { id: 'trendyol', name: 'Trendyol Express', logo: '📱' },
              'ups': { id: 'ups', name: 'UPS Türkiye', logo: '🌍' },
              'dhl': { id: 'dhl', name: 'DHL', logo: '✈️' },
              'kolay': { id: 'kolay', name: 'Kolay Gelsin', logo: '🎯' }
            };
            
            const company = companies[cargoApi.selectedCompanyForDetails];
            if (!company) return null;
            
            return (() => {
            // Teslimat durumları (Gerçek API Response'ları)
            const deliveryStatuses = [
              { id: 'created', name: 'Gönderi Toplandı - Kargo Kaydı Oluşturuldu (NOP)', icon: '📝' },
              { id: 'transfer', name: 'Kargo Teslimattadır/Kargo Yüklendi - Hareket Halinde (IND)', icon: '🚚' },
              { id: 'arrived', name: 'Kargo Teslimattadır/Kargo İndirildi - Şubeye Ulaştı (ISR)', icon: '🏢' },
              { id: 'waiting', name: 'Kargo Çıkışı Engellendi - Bekletiliyor (CNL)', icon: '⏳' },
              { id: 'cancelled', name: 'Kargo İptal Ediliyor Bilgisi (ISC)', icon: '❌' },
              { id: 'delivered', name: 'Kargo Teslim Edilmiştir - Teslim Edildi (DLV)', icon: '✅' }
            ];
            
            return (
            <div key={company.id} style={{ 
              marginBottom: '25px',
              padding: '20px', 
              background: 'white', 
              border: '1px solid #dee2e6', 
              borderRadius: '8px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <span style={{ fontSize: '24px', marginRight: '10px' }}>{company.logo}</span>
                <h4 style={{ margin: 0, color: '#495057' }}>{company.name}</h4>
              </div>
              
              <div style={{ display: 'grid', gap: '15px' }}>
                {deliveryStatuses.map((status) => (
                  <div key={status.id} style={{
                    padding: '15px',
                    background: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRadius: '8px'
                  }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#495057' }}>
                      {status.icon} {status.name}
                    </label>
                    <textarea
                      value={cargoApi.messageTemplates[company.id]?.[status.id] || ''}
                      onChange={(e) => setCargoApi(prev => ({
                        ...prev,
                        messageTemplates: {
                          ...prev.messageTemplates,
                          [company.id]: {
                            ...prev.messageTemplates[company.id],
                            [status.id]: e.target.value
                          }
                        }
                      }))}
                      rows={2}
                      placeholder={`${status.name} - Mesaj boşsa gönderilmez`}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ced4da',
                        borderRadius: '6px',
                        fontSize: '14px',
                        resize: 'vertical'
                      }}
                    />
                    
                    {/* Değişken Butonları */}
                    <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                      {[
                        { code: '[musteri-adi]', label: 'Müşteri Adı' },
                        { code: '[musteri-soyadi]', label: 'Müşteri Soyadı' },
                        { code: '[takip-no]', label: 'Takip No' },
                        { code: '[takip-linki]', label: 'Takip Linki' },
                        { code: '[kargo-sirketi]', label: 'Kargo Şirketi' },
                        { code: '[kargo-teslim-tarihi]', label: 'Teslim Tarihi' },
                        { code: '[kargo-teslimat-tarihi]', label: 'Teslimat Tarihi' }
                      ].map((variable) => (
                        <button
                          key={variable.code}
                          type="button"
                          onClick={() => {
                            const textarea = document.querySelector(`textarea[placeholder*="${status.name}"]`);
                            if (textarea) {
                              const start = textarea.selectionStart;
                              const end = textarea.selectionEnd;
                              const text = textarea.value;
                              const before = text.substring(0, start);
                              const after = text.substring(end, text.length);
                              const newValue = before + variable.code + after;
                              
                              setCargoApi(prev => ({
                                ...prev,
                                messageTemplates: {
                                  ...prev.messageTemplates,
                                  [company.id]: {
                                    ...prev.messageTemplates[company.id],
                                    [status.id]: newValue
                                  }
                                }
                              }));
                              
                              // Focus ve cursor pozisyonu
                              setTimeout(() => {
                                textarea.focus();
                                textarea.setSelectionRange(start + variable.code.length, start + variable.code.length);
                              }, 0);
                            }
                          }}
                          style={{
                            padding: '4px 8px',
                            background: '#e9ecef',
                            border: '1px solid #ced4da',
                            borderRadius: '4px',
                            fontSize: '11px',
                            cursor: 'pointer',
                            color: '#495057'
                          }}
                          title={`${variable.label} ekle`}
                        >
                          {variable.label}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              
            </div>
            );
            })();
          })()}
          
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <button
              onClick={() => {
                alert('✅ Teslimat hareketleri kaydedildi!');
              }}
              style={{
                background: '#007bff',
                color: 'white',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              💾 Teslimat Hareketlerini Kaydet
            </button>
          </div>
        </div>
        )}

        {/* Takip Edilen Kargolar */}
        {cargoApi.trackings.length > 0 && (
          <div style={{ 
            marginTop: '30px',
            padding: '20px', 
            background: '#f8f9fa', 
            border: '1px solid #e9ecef', 
            borderRadius: '10px'
          }}>
            <h3 style={{ marginBottom: '15px', color: '#495057' }}>📦 Takip Edilen Kargolar</h3>
            
            <div style={{ display: 'grid', gap: '10px' }}>
              {cargoApi.trackings.map((cargo) => (
                <div key={cargo.id} style={{
                  padding: '15px',
                  background: 'white',
                  border: '1px solid #dee2e6',
                  borderRadius: '8px',
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr auto',
                  gap: '15px',
                  alignItems: 'center'
                }}>
                  <div>
                    <div style={{ fontWeight: 'bold', color: '#495057' }}>{cargo.customer_name}</div>
                    <div style={{ fontSize: '12px', color: '#6c757d' }}>{cargo.customer_phone}</div>
                  </div>
                  <div>
                    <div style={{ fontWeight: 'bold', color: '#007bff' }}>{cargo.tracking_number}</div>
                    <div style={{ fontSize: '12px', color: '#6c757d' }}>{cargo.cargo_key}</div>
                  </div>
                  <div>
                    <div style={{ 
                      padding: '4px 8px', 
                      background: cargo.current_status === 'DLV' ? '#d4edda' : '#fff3cd',
                      color: cargo.current_status === 'DLV' ? '#155724' : '#856404',
                      borderRadius: '4px',
                      fontSize: '12px',
                      display: 'inline-block'
                    }}>
                      {cargo.current_status === 'DLV' ? '✅ Teslim Edildi' : '🔄 Takip Ediliyor'}
                    </div>
                    <div style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                      {cargo.current_operation_message || 'Durum bilgisi bekleniyor'}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '11px', color: '#6c757d' }}>
                      {new Date(cargo.created_at).toLocaleDateString('tr-TR')}
                    </div>
                    <div style={{ fontSize: '11px', color: '#6c757d' }}>
                      {cargo.status_update_count || 0} güncelleme
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Bilgi Kutusu */}
        <div style={{ 
          marginTop: '30px',
          padding: '20px', 
          background: 'linear-gradient(135deg, #e7f3ff 0%, #d1ecf1 100%)', 
          border: '2px solid #b3d9ff', 
          borderRadius: '8px',
          fontSize: '14px',
          color: '#0066cc'
        }}>
          <div style={{ fontSize: '16px', marginBottom: '10px' }}>ℹ️ <strong>Kargo Takip Sistemi Nasıl Çalışır?</strong></div>
          <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
            <li>API ile kargo oluşturulur ve otomatik takibe alınır</li>
            <li>Sistem her 30 dakikada bir kargo durumunu kontrol eder</li>
            <li>Durum değişikliklerinde müşteriye WhatsApp bildirimi gönderilir</li>
            <li>Kargo teslim edilince takip otomatik durur</li>
          </ul>
          <div style={{ marginTop: '10px', fontSize: '12px', color: '#0056b3' }}>
            🔧 Cron job: Her 30 dakikada bir tüm aktif kargoları kontrol eder
          </div>
        </div>
        </div>
      )}

      {/* QR Kod Modal */}
      {/* Sözleşme Modal */}
      {showAgreementModal && (
        <div
          onClick={() => setShowAgreementModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            padding: '20px'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white',
              borderRadius: '12px',
              width: '100%',
              maxWidth: '800px',
              maxHeight: '90vh',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
            }}
          >
            {/* Modal Header */}
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #e2e8f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#333' }}>
                {agreementType === 'membership' ? 'Hizmet Sözleşmesi' : 'Gizlilik Politikası'}
              </h2>
              <button
                onClick={() => setShowAgreementModal(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666',
                  padding: '0',
                  width: '30px',
                  height: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            {/* Modal Content */}
            <div style={{
              padding: '20px',
              overflowY: 'auto',
              flex: 1,
              whiteSpace: 'pre-wrap',
              lineHeight: '1.8',
              fontSize: '14px',
              color: '#333'
            }}>
              {agreementContent || 'Sözleşme içeriği yükleniyor...'}
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: '20px',
              borderTop: '1px solid #e2e8f0',
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setShowAgreementModal(false)}
                style={{
                  padding: '10px 24px',
                  background: '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {qrCode && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            borderRadius: '15px',
            padding: '30px',
            maxWidth: '400px',
            width: '90%',
            textAlign: 'center',
            position: 'relative'
          }}>
            <button
              onClick={() => setQrCode(null)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              ✕
            </button>
            
            <h3 style={{ marginBottom: '20px', color: '#333' }}>📱 WhatsApp QR Kodu</h3>
            
            <div style={{ marginBottom: '20px' }}>
              <img 
                src={qrCode} 
                alt="WhatsApp QR Code" 
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                  border: '2px solid #e9ecef',
                  borderRadius: '8px'
                }}
              />
            </div>
            
            <p style={{ 
              marginBottom: '20px', 
              color: '#666', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              <strong>📋 Nasıl Kullanılır:</strong><br/>
              1️⃣ Telefonunuzda WhatsApp uygulamasını açın<br/>
              2️⃣ Ayarlar → WhatsApp Web/Desktop → QR Kodu Tara<br/>
              3️⃣ Bu QR kodu telefonunuzla tarayın
            </p>
            
            <div style={{ 
              padding: '15px', 
              background: '#f8f9fa', 
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              marginBottom: '20px'
            }}>
              <p style={{ 
                margin: '0', 
                fontSize: '13px', 
                color: '#495057',
                fontWeight: '500'
              }}>
                ⚠️ QR kod 2 dakika içinde geçerliliğini yitirir.<br/>
                Süre dolduğunda "QR Kodu Göster" butonuna tekrar tıklayın.
              </p>
            </div>
            
            <button
              onClick={() => setQrCode(null)}
              style={{
                background: '#6c757d',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Kapat
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardPage; 
